<template>
  <ChipLabelInput
    :value="value"
    :chip-placeholder="'{{measure_label}}'"
    chip-label="KPI Measure Label"
    chip-tooltip="Each KPI's measure name will be inserted at chip position"
    :show-add-button="true"
    :placeholder="placeholder"
    @input="$emit('input', $event)" />
</template>

<script>
  import ChipLabelInput from '@/components/pdf_report/ChipLabelInput.vue'

  export default {
    name: 'MeasureLabelInput',
    components: { ChipLabelInput, },
    props: {
      value: {
        type: String,
        default: '',
      },
      placeholder: {
        type: String,
        default: '',
      },
    },
  }
</script>
